import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { TemplatePage } from 'pages/application/ui/TemplatePage/TemplatePage';
import { TemplatePageM } from 'pages/application/ui/TemplatePageM/TemplatePageM';
import { MpSection } from 'shared/ui/MpSection';

const MpSectionTemplate = styled(MpSection)`
	display: block;
	margin: 16px auto;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		margin: 40px auto;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

export const Template: React.FC = () => {
	const { applicationId } = useParams<{ applicationId: string }>();

	return (
		<MpSectionTemplate>
			<TemplatePage templateId={applicationId} />
			<TemplatePageM templateId={applicationId} />
		</MpSectionTemplate>
	);
};
